export const ru = {
    campaign: 'Кампания',
    group: 'Группа',
    'minus-phrases-per-group': 'Минус-фразы на группу',
    'minus-words-per-group': 'Минус-слова на группу',
    'not-specified': 'не заданы',
    region: 'Регион'
};
